// 2_components/page_title.js
// On category / manufacturer / page types (non-cs stores), replaces the first <h1>
// with the document title minus the " - Natios" / " | Natios" suffix.

export function init() {
	updatePageTitle();
}

function updatePageTitle() {
	if (window.NAT.lang === "cs") {
		return;
	}
	if (
		document.body.classList.contains("type-category") ||
		document.body.classList.contains("type-manufacturer-detail") ||
		document.body.classList.contains("type-page")
	) {
		const h1 = $("h1").first();
		let title = document.title;
		// If the first h1 isn't equal to the page title,
		if (h1.text() !== title) {
			// Change h1 to page title but remove " - Natios" or " | Natios" if it's in there
			title = title.replace(/ - Natios| - natios| \| Natios| \| natios/g, "");
			h1.text(title);
		}
	}
}
